import { AttributeForm } from "@/modules/dynamic-attributes/feature/save-simple-dynamic-attribute";
import { Attribute } from "../model/entity-attributes/types";
import { DynamicAttributeEntity } from "gql/graphql";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { useEntityAttributeById } from "../model/entity-attributes/use-entity-attribute-by-id";
import { useEditorConfig } from "../model/config/use-config";
import { useSelectedGroupId } from "../model/selected-group/use-selected-group-id";

export function EditSimpleAttribute({
  attributeId,
  afterSubmit,
}: {
  attributeId: string;
  afterSubmit?: () => void;
}) {
  const { entity, category } = useEditorConfig();
  const attribute = useEntityAttributeById(attributeId);
  const groupId = useSelectedGroupId();

  if (attribute?.__typename !== "SimpleTypeDynamicAttributeDto") {
    return null;
  }

  return (
    <AttributeForm
      afterSubmit={afterSubmit}
      dynamicAttributeEntity={entity}
      groupId={groupId}
      entity={transform({
        attribute,
        dynamicAttributeEntity: entity,
        category,
        group: groupId,
      })}
    />
  );
}

function transform({
  attribute,
  group,
  dynamicAttributeEntity,
  category,
}: {
  attribute: Attribute;
  dynamicAttributeEntity: DynamicAttributeEntity;
  category?: string;
  group?: string;
}) {
  return {
    ...attribute,
    dynamicAttributeEntity,
    group,
    category,
    description: extractLocalizedValue(attribute.description),
    name: extractLocalizedValue(attribute.name),
  };
}
